import translate from '../../../i18n'
import { ICorporatesFilterParams } from '../../../pages/corporates-container/share-type'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form, Select, Input, InputNumber } from 'antd'
import { useEffect } from 'react'

const { Option } = Select
const CorporatesFilter = ({
  onSearch,
  formData,
}: {
  onSearch: (value: ICorporatesFilterParams) => void
  formData: ICorporatesFilterParams | undefined
}) => {
  const [form] = Form.useForm()
  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData)
    }
  }, [formData])
  const onFinish = (values: ICorporatesFilterParams) => {
    onSearch(values)
  }
  return (
    <Form form={form} layout="inline" onFinish={onFinish}>
      <Form.Item name="name" label="名字">
        <Input />
      </Form.Item>

      <Form.Item name="phoneNumber" label="电话号码">
        <Input />
      </Form.Item>

      <Form.Item name="userId" label="用户ID">
        <InputNumber />
      </Form.Item>

      <Form.Item name="isActive" label="活跃">
        <Select style={{ minWidth: 130 }} allowClear>
          <Option value={true}>是</Option>
          <Option value={false}>否</Option>
        </Select>
      </Form.Item>

      <Form.Item name="principal" label={translate('corporate.principal')}>
        <Input />
      </Form.Item>

      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          搜索
        </Button>
      </Form.Item>
    </Form>
  )
}

export default CorporatesFilter
